(() => {
  const ROOT = '[data-asa]';
  const READY = 'data-asa-ready';

  const init = (root) => {
    if (!root || root.hasAttribute(READY)) return;
    if (typeof root._asaCleanup === 'function') root._asaCleanup();

    const items = Array.from(root.querySelectorAll('[data-asa-item]'));
    const images = Array.from(root.querySelectorAll('[data-asa-image]'));
    if (!items.length) return;

    root.setAttribute(READY, '');

    let openIndex = Math.max(
      0,
      items.findIndex((item) => item.classList.contains('is-open'))
    );
    if (openIndex < 0) openIndex = 0;

    const setOpen = (nextIndex) => {
      openIndex = nextIndex;

      items.forEach((item, i) => {
        const open = i === openIndex;
        const trigger = item.querySelector('[data-asa-trigger]');
        const panel = item.querySelector('[data-asa-panel]');
        const icon = item.querySelector('[data-asa-icon]');

        item.classList.toggle('is-open', open);
        if (trigger) {
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        if (panel) {
          panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        }
        if (icon) icon.textContent = open ? '×' : '+';
      });

      images.forEach((img, i) => {
        img.classList.toggle('is-active', i === openIndex);
      });
    };

    const onClick = (event) => {
      const trigger = event.currentTarget;
      const item = trigger.closest('[data-asa-item]');
      const index = items.indexOf(item);
      if (index < 0 || index === openIndex) return;
      setOpen(index);
    };

    items.forEach((item) => {
      const trigger = item.querySelector('[data-asa-trigger]');
      if (trigger) trigger.addEventListener('click', onClick);
    });

    root._asaCleanup = () => {
      items.forEach((item) => {
        const trigger = item.querySelector('[data-asa-trigger]');
        if (trigger) trigger.removeEventListener('click', onClick);
      });
      root._asaCleanup = null;
      root.removeAttribute(READY);
    };

    setOpen(openIndex);
  };

  const scan = () => {
    document.querySelectorAll(ROOT).forEach(init);
  };

  const rescan = () => {
    document.querySelectorAll(ROOT).forEach((root) => {
      if (typeof root._asaCleanup === 'function') root._asaCleanup();
    });
    scan();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', rescan);
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target && event.target.querySelector(ROOT);
    if (root && typeof root._asaCleanup === 'function') root._asaCleanup();
  });
})();
